import { useCallback } from 'react';
import { PresentationBlock } from 'shared/components/PresentationBlock';
import { RootMortgageWrapper } from 'shared/constants/common';
import { useTracking } from '../../utils/tracking/useTracking';
import { useSelector } from 'react-redux';
import { selectH1Tag } from '../../selectors/landing';

export const PresentationBlockContainer = () => {
  const { trackClickOnTargetButton } = useTracking();
  const title = useSelector(selectH1Tag);

  const onScrollToMortgageBlock = useCallback(() => {
    trackClickOnTargetButton();
    const element = document.getElementById(RootMortgageWrapper);
    element?.scrollIntoView({
      behavior: 'smooth',
    });
  }, []);

  return (
    <PresentationBlock
      title={title}
      description="Льготные программы, эксклюзивные предложения — всё здесь"
      handleClickButton={onScrollToMortgageBlock}
    />
  );
};
